// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download {
  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 45%, var(--amber-tint) 100%);
}

.download__inner {
  display: grid;
  grid-template-columns: 0.6fr 1.4fr;
  gap: 48px;
  align-items: center;
}

.download__qr-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.download__qr-card {
  width: 100%;
  max-width: 220px;
  aspect-ratio: 1 / 1;
  padding: 16px;
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-soft);
  box-shadow: var(--shadow-md);
}

.download__qr-card img {
  width: 100%;
  height: 100%;
  display: block;
}

.download__share {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-dark);
  background: #fff;
  border: 1px solid var(--border-soft);
  border-radius: 100px;
  padding: 9px 18px;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.download__share:hover {
  background: var(--teal-tint);
  color: var(--teal-dark);
  border-color: var(--teal);
  transform: translateY(-1px);
}

.download__apps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 28px;
}

.download__app {
  padding: 20px;
  border-radius: var(--radius-lg);
  background: var(--glass-light-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  /* This section's own background is a pale tint, not a photo or a dark
     gradient, so the glass fill alone doesn't give the card much edge
     definition — a visible neutral border plus a real shadow do that
     job instead, on top of each card's teal/amber top accent. */
  border: 1px solid rgba(17, 24, 39, 0.08);
  box-shadow: var(--shadow-sm);
}

.download__app--teal {
  border-top: 3px solid var(--teal);
}

.download__app--amber {
  border-top: 3px solid var(--amber);
}

.download__app-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 14px;
}

.download__app-head strong {
  font-family: var(--font-display);
  font-size: 16px;
  color: var(--text-dark);
}

.download__app-head span {
  font-size: 12.5px;
  color: var(--text-grey);
}

.download__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.download__badges a {
  display: inline-flex;
  height: 42px;
  border-radius: 9px;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: var(--shadow-sm);
}

.download__badges a:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.download__badges img {
  height: 100%;
  width: auto;
  display: block;
}

.download__badge-windows {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 42px;
  padding: 0 16px;
  border-radius: 9px;
  background: var(--text-dark);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.download__badge-windows:hover {
  background: #000;
}

@media (max-width: 860px) {
  .download__inner {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .download__apps {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DownloadSection.css"],"names":[],"mappings":"AAAA;EACE,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,yEAAyE;AAC3E;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iCAAiC;EACjC,wCAAwC;EACxC,gDAAgD;EAChD;;;gEAG8D;EAC9D,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".download {\n  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 45%, var(--amber-tint) 100%);\n}\n\n.download__inner {\n  display: grid;\n  grid-template-columns: 0.6fr 1.4fr;\n  gap: 48px;\n  align-items: center;\n}\n\n.download__qr-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.download__qr-card {\n  width: 100%;\n  max-width: 220px;\n  aspect-ratio: 1 / 1;\n  padding: 16px;\n  background: #fff;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-md);\n}\n\n.download__qr-card img {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.download__share {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-dark);\n  background: #fff;\n  border: 1px solid var(--border-soft);\n  border-radius: 100px;\n  padding: 9px 18px;\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.download__share:hover {\n  background: var(--teal-tint);\n  color: var(--teal-dark);\n  border-color: var(--teal);\n  transform: translateY(-1px);\n}\n\n.download__apps {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 28px;\n}\n\n.download__app {\n  padding: 20px;\n  border-radius: var(--radius-lg);\n  background: var(--glass-light-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  /* This section's own background is a pale tint, not a photo or a dark\n     gradient, so the glass fill alone doesn't give the card much edge\n     definition — a visible neutral border plus a real shadow do that\n     job instead, on top of each card's teal/amber top accent. */\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  box-shadow: var(--shadow-sm);\n}\n\n.download__app--teal {\n  border-top: 3px solid var(--teal);\n}\n\n.download__app--amber {\n  border-top: 3px solid var(--amber);\n}\n\n.download__app-head {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 14px;\n}\n\n.download__app-head strong {\n  font-family: var(--font-display);\n  font-size: 16px;\n  color: var(--text-dark);\n}\n\n.download__app-head span {\n  font-size: 12.5px;\n  color: var(--text-grey);\n}\n\n.download__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.download__badges a {\n  display: inline-flex;\n  height: 42px;\n  border-radius: 9px;\n  overflow: hidden;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.download__badges a:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.download__badges img {\n  height: 100%;\n  width: auto;\n  display: block;\n}\n\n.download__badge-windows {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 42px;\n  padding: 0 16px;\n  border-radius: 9px;\n  background: var(--text-dark);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.download__badge-windows:hover {\n  background: #000;\n}\n\n@media (max-width: 860px) {\n  .download__inner {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .download__apps {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
